import request from '@/utils/request'

// 搜索车牌号信息列表
export function getVehicleList(data) {
  return request.post('/vehicle/list', data)
}

// 创建加油申请
export function getList(data) {
  return request.post('/vehicle/apply/getPage', data)
}

// 创建加油申请
export function createRefuelApply(data) {
  return request.post('/vehicle/apply/save', data)
}

// 修改加油申请
export function updateRefuelApply(data) {
  return request.post('/vehicle/apply/updateById', data)
}

// 删除加油申请
export function deleteRefuelApply(data) {
  return request.post('/vehicle/apply/deleteBatch', data)
}

// 申请跳过人脸识别等验证
export function applySkipCheck(data) {
  return request.post('/vehicle/apply/applySkipFVVerify', data)
}

// 审核加油请求
export function checkApply(data) {
  return request.post('/vehicle/apply/checkApply', data);
}

// 跳过识别验证
export function checkSkipCheck(data) {
  return request.post('/vehicle/apply/checkSkipFVVerify', data);
}

// 获取加油报表
export function getRefuelReport(data) {
  return request.post('/vehicle/report/refuelReport', data);
}
// 获取加油记录
export function getRefuelRecord(data) {
  return request.post('/refuelRecord/getPage', data);
}